













































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
import version from "@/version";
import ArchiveFile from "@/data/ArchiveFile";

interface CustomEvent {
	currentTarget: HTMLElement | string | null;
}

@Component({
	...mapGetters(["accountBook"]),
})
export default class Archive extends Vue {
	nowIndex: number = -1;
	monthIndex: number = -1;
	checkAll: boolean = false;
	files: ArchiveFile[] = <ArchiveFile[]>(
		new ArchiveFile(this.$store.state.accountBook.accountingSystem).allFiles
	);
	checkedNumber: number = 0;
	hasSelected: boolean = false;
	url: string = "";
	nowMonth: string = "";
	yearIndex: number = -1;
	isDim: number = 0;
	isNum: number = 0;
	isCurr: number = 0;
	isNumCurr: number = 0;

	get startTime() {
		return +this.$store.state.accountBook.startPeriod;
	}

	get endTime() {
		return +this.$store.state.accountBook.closePeriod;
	}

	get years() {
		let endMonths = +this.endTime.toString().substr(4),
			endYear = +this.endTime.toString().substr(0, 4),
			startYear = +this.startTime.toString().substr(0, 4),
			startMonth = +this.startTime.toString().substr(4);

		let years = [];
		for (let i = 0; i <= endYear - startYear; i++) {
			let months = [];
			if (i === 0) {
				if (endYear === startYear) {
					for (let j = endMonths; j >= startMonth; j--) {
						let m = j < 10 ? "0" + j : j;
						months.push(m);
					}
				} else {
					for (let j = endMonths; j > 0; j--) {
						let m = j < 10 ? "0" + j : j;
						months.push(m);
					}
				}
			} else if (i === endYear - startYear) {
				for (let l = 12; l >= startMonth; l--) {
					let m = l < 10 ? "0" + l : l;
					months.push(m);
				}
			} else {
				for (let k = 12; k > 0; k--) {
					let m = k < 10 ? "0" + k : k;
					months.push(m);
				}
			}
			years.push({ year: endYear - i, months: months });
		}
		return years;
	}

	isShow(file: ArchiveFile) {
		console.log(file.name)
		console.log(file.name.indexOf("存货数量辅助核算明细账"))
		if(file.name.indexOf("存货数量辅助核算明细账") !== -1) {
			console.log(this.isDim,this.isNum)
			if(this.isDim === 1 && this.isNum === 1) {
				console.log("ddd")
				return true
			}
			else return false
		}
		if (file.name.indexOf("辅助") != -1) {
			if (this.isDim === 1) return true;
			else return false;
		} else if (
			file.name.indexOf("数量") != -1 &&
			file.name.indexOf("外币") === -1
		) {
			if (this.isNum === 1) return true;
			else return false;
		} else if (
			file.name.indexOf("数量") === -1 &&
			file.name.indexOf("外币") != -1
		) {
			if (this.isCurr === 1) return true;
			else return false;
		} else if (file.name.indexOf("数量外币") != -1) {
			if (this.isNumCurr === 1) return true;
			else return false;
		} else {
			return true;
		}
	}

	/*
	 * 左侧区域的函数
	 */
	// 点击关闭
	clickClose() {
		this.$emit("close");
	}
	// 获取是否有数量外币
	getCurNum(isYear: boolean) {
		Vue.axios
			.post("balances/check", {
				accountBookId: this.$store.state.accountBook.id,
				startPeriod: isYear
					? this.years[this.yearIndex].year.toString() +
					this.years[this.yearIndex].months[
					this.years[this.yearIndex].months.length - 1
					]
					: this.nowMonth,
				endPeriod: isYear
					? this.years[this.yearIndex].year.toString() +
					this.years[this.yearIndex].months[0]
					: this.nowMonth,
			})
			.then((response) => {
				this.isDim = response.data.isDim;
				this.isNumCurr = response.data.isNumCurr;
				this.isNum = response.data.isNum;
				this.isCurr = response.data.isCurr;
			});
	}
	//点击后的样式更改
	syncStyle(index: number, event: Event | CustomEvent) {
		this.nowIndex = index;
		let svgs = <NodeListOf<HTMLElement>>(
			document.querySelectorAll(".left-area svg")
		);
		svgs.forEach((element: HTMLElement) => {
			element.style.color = "#CDCDCD";
		});
		let active = <NodeListOf<HTMLElement>>(
			document.querySelectorAll(".line-active")
		);
		active.forEach((v: HTMLElement) => {
			v.classList.remove("line-active");
			(<SVGSVGElement>v.querySelector("svg")).classList.remove(
				"main-color-text"
			);
		});
		let activeRow = <NodeListOf<HTMLElement>>(
			document.querySelectorAll(".lighter-main-color-background")
		);
		activeRow.forEach((v: HTMLElement) => {
			v.classList.remove("lighter-main-color-background");
		});
		if (event.currentTarget != null) {
			(<HTMLElement>event.currentTarget).classList.add("line-active");
			(<SVGSVGElement>(
				(<HTMLElement>event.currentTarget).querySelector("svg")
			)).classList.add("main-color-text");
		}
	}
	//点击年
	clickYear(index: number, event: Event) {
		this.syncStyle(index, event);
		this.monthIndex = -1;
		this.yearIndex = index;
		this.getCurNum(true);
		this.files = <ArchiveFile[]>(
			new ArchiveFile(this.$store.state.accountBook.accountingSystem)
				.yearFiles
		);
		for (let i = 0; i < this.years[index].months.length; i++) {
			let ele = this.years[index].months[i];
			let one = new ArchiveFile(
				this.$store.state.accountBook.accountingSystem,
				ele + "月",
				`month${+ele}`
			).one;
			this.files.splice(0, 0, <ArchiveFile>one);
		}
	}
	//判断是否为当前月
	isNowMonth(curYear: number, curMonth: number) {
		return this.nowIndex === curYear && this.monthIndex === curMonth;
	}
	//点击月
	clickMonth(
		index: number,
		event: Event | CustomEvent,
		i: number,
		month: string
	) {
		this.syncStyle(index, event);
		this.monthIndex = i;
		this.nowMonth = month;
		this.getCurNum(false);
		this.files = <ArchiveFile[]>(
			new ArchiveFile(this.$store.state.accountBook.accountingSystem)
				.allFiles
		);
		this.yearIndex = -1;
	}

	/*
	 * 右侧区域的函数
	 */
	// 监听选中的文件
	@Watch("files", { deep: true })
	filesChanged(val: ArchiveFile[]) {
		this.hasSelected = this.hasTrue(val);
		let number: number = 0;
		let rows = <NodeListOf<HTMLElement>>(
			document.querySelectorAll("#Archive .right-area tbody tr")
		);
		for (let i = 0; i < rows.length; i++) {
			let row = rows[i];
			if (row != undefined) {
				let name = (<HTMLElement>row.querySelector(".fileText span"))
					.innerText;
				for (let j = 0; j < val.length; j++) {
					if (val[j].name === name) {
						if (val[j].checked) {
							number++;
							row.classList.add("lighter-main-color-background");
						} else {
							if (
								row.classList.contains(
									"lighter-main-color-background"
								)
							)
								row.classList.remove(
									"lighter-main-color-background"
								);
						}
					} else {
						continue;
					}
				}
			}
		}
		this.checkedNumber = number;
		if (this.checkedNumber === rows.length && this.checkedNumber != 0)
			this.checkAll = true;
		else this.checkAll = false;
	}
	// 封装array是否有true
	hasTrue(val: ArchiveFile[]) {
		for (let i = 0; i < val.length; i++) {
			if (val[i].checked) return true;
			else continue;
		}
		return false;
	}
	// 全选所有文件
	selectAll(val: boolean) {
		for (let i = 0; i < this.files.length; i++) {
			if (this.isShow(this.files[i]))
				Vue.set(this.files[i], "checked", val);
		}
	}
	//显示/隐藏当前行的下载
	showDl(e: MouseEvent) {
		(<HTMLElement>(
			(<HTMLElement>e.currentTarget).querySelector(".dl")
		)).style.display = "inline-block";
	}
	hideDl(e: MouseEvent) {
		(<HTMLElement>(
			(<HTMLElement>e.currentTarget).querySelector(".dl")
		)).style.display = "none";
	}
	// 选中当前行
	selectRow(i: number) {
		if (!this.files[i].checked) {
			Vue.set(this.files[i], "checked", true);
		} else {
			Vue.set(this.files[i], "checked", false);
		}
	}

	singleDown(type: number, file: ArchiveFile) {
		console.log(file);
		let pre;
		if (type === 0) pre = `${Vue.axios.defaults.baseURL}export/`;
		else pre = `${Vue.axios.defaults.baseURL}export/pdf/`;

		let start: string, end: string;
		if (this.yearIndex === -1) {
			start = end = this.nowMonth;
		} else {
			start =
				this.years[this.yearIndex].year.toString() +
				this.years[this.yearIndex].months[
					this.years[this.yearIndex].months.length - 1
				].toString();
			end =
				this.years[this.yearIndex].year.toString() +
				this.years[this.yearIndex].months[0].toString();
		}
		if (file.name != "总账" && file.name === "凭证") {
			if (type != 0) {
				this.url = `${pre}voucher?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${start}&endPeriod=${end}&version=${version}&token=${this.$store.state.account.token}`;
			} else
				this.url = `${pre}${file.eng}?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${start}&endPeriod=${end}&version=${version}&token=${this.$store.state.account.token}`;
		} else if (file.name != "总账")
			this.url = `${pre}${file.eng}?accountBookId=${this.$store.state.accountBook.id}&startPeriod=${start}&endPeriod=${end}&version=${version}&token=${this.$store.state.account.token}`;
		else
			this.url = `${pre}${file.eng}?accountBookId=${this.$store.state.accountBook.id
				}&startPeriod=${this.years[this.yearIndex].year
				}&version=${version}&token=${this.$store.state.account.token}`;
		if (file.name === "余额表") {
             this.url = `${pre}${file.eng}?accountBookId=${this.$store.state.accountBook.id}&isBNLJ=${1}&startPeriod=${start}&endPeriod=${end}&version=${version}&token=${this.$store.state.account.token}`;
		}
		this.mainDownload();
	}

	clickFolder(file: ArchiveFile) {
		if (file.isMonth) {
			let year = this.years[this.yearIndex].year.toString(),
				monthIndex = -1,
				event = {
					currentTarget: "",
				},
				leftCurMonth: string = "",
				leftCurList = <NodeListOf<Element>>(
					document.querySelectorAll(`.one-period`)
				);

			for (let i = 0; i < leftCurList.length; i++) {
				if (leftCurList[i].getAttribute("year") === year) {
					let lis = leftCurList[i].querySelectorAll("li");
					for (let j = 0; j < lis.length; j++) {
						if (
							(<HTMLElement>lis[j].querySelector(".monthText"))
								.innerText === file.name
						) {
							// @ts-ignore
							event.currentTarget = lis[j];
							monthIndex = j;
						} else continue;
					}
				} else continue;
			}
			this.clickMonth(
				this.yearIndex,
				event,
				monthIndex,
				year.toString() + file.name.split("月")[0].toString()
			);
		}
	}

	//批量下载  0 excel 1 pdf
	lotDown(type: number) {
		let checkedStr: string[] = [],
			year: number | null = null,
			startPeriod: string = "",
			endPeriod: string = "";

		if (this.monthIndex === -1) {
			let yearObj = this.years[this.yearIndex];
			year = yearObj.year;
			startPeriod =
				year.toString() + yearObj.months[yearObj.months.length - 1];
			endPeriod = year.toString() + yearObj.months[0];
		} else {
			startPeriod = endPeriod = this.nowMonth;
		}

		if (this.checkedNumber > 1) {
			this.files.forEach((v) => {
				if (v.checked) {
					checkedStr.push(v.eng);
				}
			});
			if (type === 0) {
				this.url = `${Vue.axios.defaults.baseURL
					}export/zip?accountBookId=${this.$store.state.accountBook.id
					}&year=${year}&startPeriod=${startPeriod}&endPeriod=${endPeriod}&checkedStr=,${checkedStr.join(",")},&version=${version}&token=${this.$store.state.account.token}`;
			} else {
				this.url = `${Vue.axios.defaults.baseURL
					}export/pdf/zip?accountBookId=${this.$store.state.accountBook.id
					}&year=${year}&startPeriod=${startPeriod}&endPeriod=${endPeriod}&checkedStr=,${checkedStr.join(",")},&version=${version}&token=${this.$store.state.account.token}`;
			}

			this.mainDownload();
		} else {
			let file: ArchiveFile = new ArchiveFile(
				this.$store.state.accountBook.accountingSystem
			);
			this.files.forEach((v) => {
				if (v.checked) {
					file = v;
				}
			});
			if (!file.isMonth) this.singleDown(type, file);
			else {
				if (type === 0)
					this.url = `${Vue.axios.defaults.baseURL}export/zip?accountBookId=${this.$store.state.accountBook.id}&year=${year}&startPeriod=${startPeriod}&endPeriod=${endPeriod}&checkedStr=,${file.eng},&version=${version}&token=${this.$store.state.account.token}`;
				else
					this.url = `${Vue.axios.defaults.baseURL}export/pdf/zip?accountBookId=${this.$store.state.accountBook.id}&year=${year}&startPeriod=${startPeriod}&endPeriod=${endPeriod}&checkedStr=,${file.eng},&version=${version}&token=${this.$store.state.account.token}`;

				this.mainDownload();
			}
		}
	}

	changeCheck(val: ArchiveFile) {
		val.checked = !val.checked;
	}

	mainDownload() {
		this.$store.dispatch("toggleDownload", true);
		this.$utils.sendToElectron("download", this.url);
	}
}
